import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { PointChangeFragment } from '@occc/graphql';

import { PointChangeView } from '@occc-app/routes/Transactions/PointChangeView/PointChangeView';
import { pageTitle } from './copies';
import { useLinks } from './hooks';

type Props = {
  pointChange: PointChangeFragment;
};

export const MemberPointChangeDetailsPage = (props: Props) => {
  const { id, membership } = props.pointChange;

  useAppLayoutContextConsumer(useLinks(membership, id));

  return (
    <Page browserTabTitle={pageTitle} pageHeaderProps={{ title: pageTitle }}>
      <PointChangeView pointChange={props.pointChange} />
    </Page>
  );
};
